import React from "react";
import "./services.css";
import Servicescomp from "..//../components/services/Servicescomp";

export default function Services() {
  return (
    <div className="servicescontainer4">
      <div className="headingyase">
        <h2>Our Services</h2>
      </div>
      <Servicescomp />
    </div>
  );
}
